import { useRecoilValue } from 'recoil';
import { useApiQuery, useTranslation } from '@zurich/common/hooks';
import { getVSGAPhoto } from '~/lib/api/documents/getVSGAPhoto';
import { autoPhotoUploadURLUniqueKeySelectorFamily } from '~/state';

export const useGetPhotoBlob = (id: string) => {
  const { t } = useTranslation();
  const photo = useRecoilValue(
    autoPhotoUploadURLUniqueKeySelectorFamily({ id })
  );

  const { fileId, documentId } = photo;

  return useApiQuery({
    request: getVSGAPhoto,
    params: {
      vars: {
        documentId: documentId ?? '',
        fileId: fileId ?? '',
      },
    },
    options: {
      errorText: t('document.errors.loadDocument'),
    },
    queryKey: [id, fileId, documentId],
    queryOptions: {
      enabled: !!documentId && !!fileId,
    },
  });
};
